/* eslint-disable react/prop-types */
import React from "react";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { blue } from "@mui/material/colors";

const FAQs = ({ planGroups, selectedPlanType, track }) => {
  const planGroup = planGroups.find(
    (pg) => pg.sk.split("_")[2] === selectedPlanType.code
  );

  const faqs = planGroup ? planGroup.FAQ || [] : [];
  
  // console.log(faqs)

  return (
    <>
      {faqs.length > 0 && (
        <Typography
          variant="h6"
          sx={{
            margin: "8px 0",
            padding: "0 8px",
            alignItems: "center",
            backgroundColor: blue[700],
            color: "white",
          }}
        >
          FAQs
        </Typography>
      )}
      {faqs &&
        faqs.map((faq) => (
          <Accordion
            key={faq.name}
            // Guard on `expanded` so collapsing the panel does not count twice.
            // FAQs have no stable id - the question text is all we have, so a
            // reworded question starts a new bucket.
            onChange={(_e, expanded) =>
              expanded &&
              track &&
              track({
                event_type: "expand",
                item_type: "faq",
                item_id: `${planGroup?.sk || "unknown"}#${faq.name}`,
                item_name: faq.name,
                plan_type: selectedPlanType?.code,
              })
            }
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={faq.name}
              id={faq.name}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                {faq.name}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2">{faq.value}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
    </>
  );
};

export default FAQs;
